//#region import libraries
import React, { useEffect, useState } from 'react';

// bootstrap
import { Row, Col } from 'react-bootstrap';

// tremor 
import { Tab, TabList } from "@tremor/react";

// custom components
import { Title, NewScreen } from "_atoms";
import { ChatSettings } from '_molecules';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { getSupportDesk, selectSupportDesk, selectSupportDeskStatus } from '_redux/slices/messaging/messaging';
import { selectFirebaseInfo } from '_redux/slices/main-screen/user';

// page 
import MessagingPage from './messaging';
import SupportDeskOnboardingPage from './onboarding';
//#endregion

const SupportDesk = (props) => {

    //#region redux
    const dispatch = useDispatch();
    const dbUser = useSelector(selectFirebaseInfo);
    const status = useSelector(selectSupportDeskStatus);
    const supportDesk = useSelector(selectSupportDesk);

    // local states
    const [tab, setTab] = useState(1);
    const [showOnboard, setShowOnboard] = useState(false);

    //#region useEffect
    useEffect(() => {
        if (dbUser && dbUser.details && dbUser.details.authority) { dispatch(getSupportDesk(dbUser.details.authority)) }
    }, []);

    useEffect(() => {
        if (status == 'succeeded') {
            // check if we show user messages or onboarding screen
            if (supportDesk == null || supportDesk == undefined) {
                // desk does not exsist show onboarding
                setShowOnboard(true)
            }
        }
        if (supportDesk) {
            setShowOnboard(false);
        }
    }, [status, supportDesk]);

    //#endregion

    return (
        <NewScreen>

            <Row>
                <Col>
                    {/* Title */}
                    <Title subtitle={"Support Desk"} description={"Interact and provide quick solutions with passengers on the PRM Assist App"} />
                </Col>
            </Row>

            {!showOnboard ?
                <>
                    <Row>
                        <TabList
                            defaultValue={tab}
                            onValueChange={(value) => setTab(value)}
                            marginTop="mt-6"
                        >
                            <Tab value={1} text="Passenger Chats" />
                            <Tab value={2} text="Control Panel" />
                        </TabList>
                    </Row>

                    {/* Messaging Chat */}
                    {tab == 1 ? <MessagingPage /> : <ChatSettings />}
                </>

                :

                /* Onboarding Page */
                <SupportDeskOnboardingPage />

            }

        </NewScreen>
    );
};

export default SupportDesk;
